import { useState } from "react";
import Layout from "../../../components/custom/Layout";
import { Manual } from "../../../globals/interfaces";
import apiClient from "../../../apiClient";
import useSWR from "swr";
import VirtualTable from "../../../components/custom/VirtualTable";
import styled from "styled-components";
import ActionIcon from "../../../components/custom/ActionIcon";
import ModalManageManual from "./ModalManageManual";
import { useAppContext } from "../../../context";
import _ from "lodash";

const fetcher = async (endpoint: string): Promise<Array<Manual>> => {
    try {
        const res = await apiClient.get(endpoint);
        return res.data;
    } catch (err) {
        return [];
    }
}

export default function ManageManual () {

    const { user } = useAppContext();
    const {
        data,
        mutate
    } = useSWR(`/manual`, fetcher, {
        fallbackData: []
    });

    const [modal, setModal] = useState(false);
    const [item, setItem] = useState<Manual>();

    const handleManage = (item?: Manual) => {
        setItem(item);
        setModal(true);
    }

    const createManual = async (newItem: Manual) => {
        try {
            const res = await apiClient.post(`/manual`, newItem);
            const created = res.data;
            const newData = [created, ...data]
            mutate(newData);
        } catch (err) {
            alert(err);
        }
    }

    const updateManual = async (updateItem: Manual) => {
        try {
            const res = await apiClient.put(`/manual`, updateItem);
            const updated = res.data;
            const updateIndex = data.findIndex(item => item.id === updateItem.id);
            const copy = _.cloneDeep(data);
            copy[updateIndex] = updated;
            mutate(copy);
        } catch (err) {
            alert(err);
        }
    }

    const deleteManual = async (id: number) => {
        try {
            const res = await apiClient.delete(`/manual/${id}`);
            const updatedData = data.filter(item => item.id !== id);
            mutate(updatedData);
        } catch (err) {
            alert(err);
        }
    }


    return (
        <Layout>
            <FlexContainer>
                <h1>Manage Manuals</h1>
                <ActionIcon type={'add'} onClick={handleManage} />
            </FlexContainer>
            <VirtualTable 
                data={data}
                mapping={[{
                    name: 'Name',
                    value: 'name'
                }, {
                    name: 'Created By',
                    value: 'createdBy',
                    email: true
                }, {
                    name: 'Created At',
                    value: 'createdAt',
                    datetime: true,
                    utc: true
                }]}
                numRows={10}
                handleClick={item => handleManage(item)}
            />
            <ModalManageManual 
                modal={modal}
                setModal={setModal}
                user={user}
                data={data}
                item={item}
                createManual={createManual}
                updateManual={updateManual}
                deleteManual={deleteManual}
            />
        </Layout>
    );
}

const FlexContainer = styled.div`
    display: flex;
    justify-content: space-between;
`;